import React from 'react';
// styles
import useStyles from '../../../assets/styles/jss/pages/exploreHome/bannerTestingStyle'
import clsx from 'clsx';
//material
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

//assets/images
import ResponsiveContainer from '../../../shared/components/ResponsiveContainer/ResponsiveContainer';
import {Hidden} from '@material-ui/core';

import {eventData, eventTracker} from '../../../shared/components/EventTracker/EventTracker';
import Banner from './Banner';
import moment from "moment";

export const banners = [
    {
        img: '/images/home/banner-B1.png',
        desc: {
            texts: [
                {
                    text: 'Entérate también de toda nuestra oferta educativa en cursos, bachillerato, licenciaturas y maestrías 100% en línea.',
                    style: {
                        variant: 'h3',
                        color: 'orange-300'
                    },
                }
            ]
        },
        btn1: {
            title: 'Conoce más',
            link: ''
        },
        btn2: {
            title: 'Para Empresas',
            link: 'https://b2b.talisis.com'
        }
    },
    {
        img: '/images/home/banner-B2.png',
        imgSecondary1: '/images/home/todo-talisis.svg',
        imgSecondary2: '/images/home/a-traves-de.svg',
        desc: {
            texts: [
                {
                    text: 'Estudia Bachillerato, Licenciatura o Maestría 100% online a tu propio ritmo con validez ante la SEP.',
                    style: {
                        variant: 'h3',
                        color: 'orange-300'
                    },
                }
            ]
        },
        btn1: {
            title: 'Regístrate aquí',
            link: ''
        },
        btn2: {
            title: '¿Qué es Talisis?',
            link: 'https://quienessomos.talisis.com'
        },
        startDate: '2025-04-18',
        endDate: '2040-12-31',
    },
    {
        img: '/images/home/banner-B3.png',
        desc: '¿Quieres retener el talento y fortalecer la lealtad en tu empresa?',
        btn1: {
            title: 'Solicitar Demo',
            link: 'https://b2b.talisis.com'
        },
        btn2: {
            title: 'Ver video',
            link: 'https://youtu.be/vzcH1fRQnEo?si=_bHZ9bVAu8YvoUBc'
        },
        startDate: '2025-04-18',
        endDate: '2040-12-31',
    },
    {
        img: '/images/home/banner-summer-B4.png',
        imgXs: '/images/home/banner-summer-B4-xs.png',
        imgSecondary1: '/images/home/promo-banner-B4.png',
        desc: {
            texts: [
                {
                    text: '15% de descuento en Plazo Anual',
                    style: {
                        variant: 'h2',
                        color: 'blue-300'
                    },
                },
                {
                    text: 'Aprender sí es una bendición. Aprovecha estos días y comienza a tu propio ritmo con nuestros programas 100% en línea: Bachillerato, Licenciatura o Maestría.',
                    style: {
                        variant: 'h3',
                        color: 'white'
                    },
                },
                {
                    text: 'Utiliza el código: div15',
                    style: {
                        variant: 'h2',
                        color: 'orange-300'
                    },
                },
            ],

        },
        downTitleImg: true,
        fullBgImage: true,
        rootBgLarge: true,
        btn1: {
            title: 'Empieza ya',
            link: 'https://www.talisis.com/membresias'
        },
        startDate: '2025-04-13',
        endDate: '2025-04-17',
    },
]


const BannerTesting = ({onClickLogin, type}) => {
    const classes = useStyles();

    const handleToEvent = () => {

        eventData['source'] = 'ExploreHome';
        eventData['NameBanner'] = banners[type].btn1.title;
        eventData['LinkBanner'] = banners[type].btn1.link;
        eventTracker('Banner', eventData, ['mixpanel']);
    };

    if (type === 2) {
        return <Banner onClickLogin={onClickLogin}/>
    }

    // if (
    //     !(banners[type]?.startDate && banners[type]?.endDate &&
    //         moment().startOf('day').isSameOrAfter(moment(banners[type]?.startDate, 'YYYY-MM-DD').startOf('day')) &&
    //         moment().startOf('day').isSameOrBefore(moment(banners[type]?.endDate, 'YYYY-MM-DD').startOf('day')))
    // ) return <Banner onClickLogin={onClickLogin}/>

    return (
        <Box className={clsx(classes.root, (banners[type]?.rootBgLarge && classes.rootBgLarge))}>
            <div className={classes.bgResponsive}></div>
            <Hidden smDown>
                <img src={banners[type].img}
                     className={clsx(classes.bg, (banners[type]?.fullBgImage && classes.fullBgImage))}/>
            </Hidden>
            <Hidden smUp>
                <img src={banners[type].imgXs} className={classes.bgImage}/>
            </Hidden>
            <ResponsiveContainer className={classes.responsiveContainer}>
                <Box width={600} display='flex' gridGap={24} flexDirection='column'
                     className={clsx(classes.container, (banners[type]?.downTitleImg && classes.downTitleImg))}>
                    {banners[type]?.imgSecondary1 && (
                        <img src={banners[type]?.imgSecondary1} className={classes.imgPrimary}/>)}
                    {banners[type]?.imgSecondary2 && (
                        <img src={banners[type]?.imgSecondary2} className={classes.imgSecondary}/>)}

                    <Box width={'100%'} display='flex' gridGap={24} flexDirection='column'>
                        {banners[type]?.desc?.texts.map((desc) => (<Typography variant={desc?.style?.variant}
                                                                               className={`text-${desc?.style?.color}`}
                                                                               align='left'>{desc?.text}</Typography>))}
                    </Box>
                    <Box className={classes.actions}>
                        {
                            banners[type].btn1.link
                                ? <Button variant="contained" color="primary" href={banners[type].btn1.link}
                                          onClick={handleToEvent} target="_blank">{banners[type].btn1.title}</Button>

                                : <Button variant="contained" color="primary"
                                          onClick={onClickLogin}>{banners[type].btn1.title}</Button>
                        }
                        {banners[type]?.btn2 && (
                            <Link href={banners[type].btn2.link} target="_blank" underline="hover" color="secondary"
                                  variant="body2" className="semi-bold">{banners[type].btn2.title}</Link>)}
                    </Box>
                </Box>
            </ResponsiveContainer>
        </Box>
    )
        ;
};

export default BannerTesting;